/* eslint-disable @nx/enforce-module-boundaries */
import { forwardRef, useContext, useEffect, useState } from 'react';
import { DiskContext } from '../context';
import {
  Box,
  Button,
  HStack,
  IconButton,
  Link,
  List,
  ListItem,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@mybridge/ui';
import { ArrowDropDownIcon, ChevronDown, ChevronRight } from '@mybridge/icons';
import { getUserFullName, toPascalCase } from 'v4/lib/commons';
import { isDir, isRootDir } from 'v4/components/utils';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const DiskBreadCrumbBar = forwardRef(({ nameGetter, ...props }, ref) => {
  const {
    history,
    setHistory,
    selectedDir,
    selectedMainDir,
    setSelectedMainDir,
    setSelectedDir,
    selectedSharedDiskUser,
    setSelectedSharedDiskUser,
    setSelectedMainDirType,
    selectedMainDirType,
  } = useContext(DiskContext);

  const nameGetterFunction = nameGetter ?? ((item) => item?.name);
  const { t } = useTranslator();

  useEffect(() => {
    if (selectedDir && selectedDir?.id !== history?.[history.length - 1]?.id) {
      push(selectedDir);
    }
  }, [selectedDir]);

  // useEffect(() => {
  //   if (selectedSharedDiskUser?.id) {
  //     console.log(selectedSharedDiskUser);
  //     setHistory([selectedSharedDiskUser]);
  //   }
  // }, [selectedSharedDiskUser]);

  useEffect(() => {
    if (selectedSharedDiskUser?.id) {
      setHistory([selectedSharedDiskUser]);
    } else if (selectedMainDir?.id) {
      setHistory([selectedMainDir]);
    }
  }, [selectedMainDir, selectedSharedDiskUser]);

  const push = (file) => {
    const history_ = [...(history ?? [])];
    history_.push(file);
    setHistory([...history_]);
  };

  const pop = () => {
    const history_ = [...(history ?? [])];
    history_?.pop?.();
    setHistory([...history_]);
  };

  const handleItemClick = (index) => {
    const selected = history[index];
    if (selected?.email) {
      setSelectedMainDir(null);
      setSelectedSharedDiskUser(selected);
      setSelectedMainDirType('shared-disk');
    } else {
      if (selected?.isMainDir) {
        setSelectedMainDir(selected);
      } else {
        setSelectedDir(selected);
      }
      let history_ = [...(history ?? [])];
      const nHistory = history_?.splice(0, index + 1);
      setHistory(nHistory);
    }
  };
  const firstItem = history?.[history.length - 1];
  const secondItem = history?.[history.length - 2];

  if (selectedMainDirType === 'my-disk' && !selectedMainDir?.id) {
    return (
      <Text fontWeight="400" color="brandPrimary.500" width="max-content">
        {t('myDisk.myDisk') || "My Disk"}
      </Text>
    );
  }
  if (selectedMainDirType === 'team-disk' && !selectedMainDir?.id) {
    return (
      <Text fontWeight="400" color="brandPrimary.500" width="max-content">
        {t('myDisk.teamDisks') || "Team Disks"}
      </Text>
    );
  }
  if (selectedMainDirType === 'shared-disk' && !selectedSharedDiskUser?.id) {
    return (
      <Text fontWeight="400" color="brandPrimary.500" width="max-content">
        {t('myDisk.sharedDisks') || "Shared Disks"}
      </Text>
    );
  }

  return (
    <>
      <HStack>
        <Box>
          {history?.length > 2 ? (
            <Popover matchWidth={true}>
              <PopoverTrigger>
                <IconButton variant="ghost" size="sm">
                  <ArrowDropDownIcon width="10" height="10" />
                </IconButton>
              </PopoverTrigger>
              {history?.length > 2 ? (
                <PopoverContent p={0} w="48">
                  <PopoverBody
                    p={0}
                    maxH="32"
                    _hover={{ overflowY: 'auto' }}
                    overflow="hidden"
                  >
                    <List p={0} flexDir="column-reverse" display="flex">
                      {history
                        ?.filter?.((_, ind) => ind < history.length - 2)
                        ?.map?.((h, hIndex) => (
                          <ListItem
                            cursor="pointer"
                            _hover={{ bg: 'gray.100' }}
                            p={2}
                            key={hIndex}
                            onClick={(e) => handleItemClick(hIndex)}
                          >
                            {h?.email
                              ? getUserFullName(h)
                              : isRootDir(h)
                              ? toPascalCase(nameGetterFunction(h))
                              : nameGetterFunction(h)}
                          </ListItem>
                        ))}
                    </List>
                  </PopoverBody>
                </PopoverContent>
              ) : (
                ''
              )}
            </Popover>
          ) : (
            ''
          )}
        </Box>
        {secondItem?.id ? (
          <Text
            truncate maxW="48"
            as={Link}
            fontWeight="500"
            onClick={(e) => handleItemClick(history.length - 2)}
            color="brandPrimary.500"
            title={
              secondItem?.email
                ? getUserFullName(secondItem)
                : isRootDir(secondItem)
                ? toPascalCase(nameGetterFunction(secondItem))
                : nameGetterFunction(secondItem)
            }
          >
            {secondItem?.email
              ? getUserFullName(secondItem)
              : isRootDir(secondItem)
              ? toPascalCase(nameGetterFunction(secondItem))
              : nameGetterFunction(secondItem)}
          </Text>
        ) : (
          ''
        )}
        {history?.length > 1 ? (
          <Box p={2}>
            <ChevronRight width="10" height="10" />
          </Box>
        ) : (
          ''
        )}
        {firstItem?.id ? (
          
          <Text
            truncate maxW="48"
            {...(history.length <= 1
              ? { fontWeight: '400', color: 'brandPrimary.500' }
              : {})}
            title={
              firstItem?.email
                ? getUserFullName(firstItem)
                : isRootDir(firstItem)
                ? toPascalCase(nameGetterFunction(firstItem))
                : nameGetterFunction(firstItem)
            }
          >
            {firstItem?.email
              ? getUserFullName(firstItem)
              : isRootDir(firstItem)
              ? toPascalCase(nameGetterFunction(firstItem))
              : nameGetterFunction(firstItem)}
          </Text>
        ) : (
          ''
        )}
      </HStack>
    </>
  );
});
